"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Card-Instructor.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    WSAdapt_template = require("../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_attrs0 = {
        "class": "col-lg-3 col-sm-4"
      },
    marko_attrs1 = {
        "class": "col"
      },
    marko_attrs2 = {
        "class": "strong"
      },
    marko_attrs3 = {
        "data-render": "Profile",
        "data-container": "#A-switch",
        "data-profile-id": "userID"
      },
    marko_attrs4 = {
        "class": "text-muted font-small-3"
      },
    marko_attrs5 = {
        "class": "text-ellipsis-2"
      };

function render(input, out, __component, component, state) {
  var data = input;

  WSAdapt_tag({
      ns: "col-md-4 col-sm-6",
      qs: "col-6",
      hs: "col-lg-6 col-sm-12",
      class: "row m-0 mb-4",
      renderBody: function(out) {
        out.e("div", marko_attrs0, "1", component, 1)
          .e("img", {
              "class": "rounded-circle w-100",
              src: corsProxy(input.photo),
              alt: "avatar"
            }, "2", component, 0);

        out.be("div", marko_attrs1, "3", component);

        out.e("h6", marko_attrs2, "4", component, 1)
          .t(input.name, component);

        if (input.email) {
          out.e("p", marko_attrs4, "5", component, 1)
            .t(input.email, component);
        }

        if (input.super && input.super.bio) {
          out.e("p", marko_attrs5, "6", component, 1)
            .t(input.super.bio, component);
        }

        out.be("a", marko_attrs3, "7", component);

        Locale_tag({
            text: "View Profile"
          }, out, __component, "8");

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
